import { h } from 'preact';
import LoadingWrapper from '../../../../internal/LoadingWrapper';
import StoredCardFields from './StoredCardFields';
import Installments from './Installments';

export const StoredCardFieldsWrapper = ({
    // base (shared)
    // n/a
    // vars created in CardInput:
    sfpState,
    setFocusOn,
    cvcPolicy,
    focusedElement,
    hasInstallments,
    handleInstallments,
    showAmountsInInstallments,
    showContextualElement,
    // props passed through from CardInput:
    hasCVC,
    installmentOptions,
    lastFour,
    expiryMonth,
    expiryYear
}) => {
    return (
        <LoadingWrapper status={sfpState.status}>
            <StoredCardFields
                errors={sfpState.errors}
                brand={sfpState.brand}
                hasCVC={hasCVC}
                cvcPolicy={cvcPolicy}
                onFocusField={setFocusOn}
                focusedElement={focusedElement}
                valid={sfpState.valid}
                lastFour={lastFour}
                expiryMonth={expiryMonth}
                expiryYear={expiryYear}
                showContextualElement={showContextualElement}
            />

            {hasInstallments && (
                <Installments
                    brand={sfpState.brand}
                    installmentOptions={installmentOptions}
                    onChange={handleInstallments}
                    type={showAmountsInInstallments ? 'amount' : 'months'}
                />
            )}
        </LoadingWrapper>
    );
};
